// extracted by mini-css-extract-plugin
export default {"blogsWrapper":"Blog_blogsWrapper__cDcJ7","blog":"Blog_blog__XlEDP"};